module.exports = __webpack_public_path__ + "static/media/selo-diamante-de-inovacao.c3d4be3b.png";